<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2 m-0">{{data?.title || ('Delete "' + (data?.description || 'Pin') + '"?')}}</p>
  <p class="text-sm text-[var(--base-text-alt-dark)] leading-relaxed">
    {{data?.message || ('This pin on ' + (data?.field || '-') + ' will be permanently removed along with any linked samples.')}}
  </p>
  <div class="flex justify-end gap-3 mt-4">
    <button (click)="close()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="deleteItemById()"
      class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-white hover:opacity-90 transition"
      [ngClass]="data?.confirmColor === 'primary' ? 'bg-[var(--primary-dark)]' : 'bg-[var(--notification-error)]'">
      {{data?.confirmLabel || 'Delete'}}
    </button>
  </div>
</div>
